const CLUB_QA_GOALS = {
  nodeTimer: 'club__nodeTimer', // узел таймера
  nodeButtonPayment: 'club__nodeButtonPayment', // узел кнопки 'Оплатить'
  nodePriceWithoutClub: 'club__nodePriceWithoutClub', // узел полной НЕ клубной цены
  nodePriceClub: 'club__nodePriceClub', // узел полной клубной цены
  nodePriceNow: 'club__nodePriceNow', // узел цены для оплаты сейчас
  nodePriceLpu: 'club__nodePriceLpu', // узел цены для оплаты в клинике
  nodeEmailSendInput: 'club__nodeEmailSendInput', // узел для ввода 'email'
  nodeEmailSendButton: 'club__nodeEmailSendButton', // узел кнопки 'Отправить email'
  appointmentNoticeDiscount: 'club__appointmentNoticeDiscount', // в компоненте "ClubAppointmentNotice" скидка на прием
  appointmentNoticeClubPrice: 'club__appointmentNoticeClubPrice', // в компоненте "ClubAppointmentNotice" клубная цена
  appointmentNoticeLpuPrice: 'club__appointmentNoticeLpuPrice', // в компоненте "ClubAppointmentNotice" обычная цена
  appointmentNoticeSavingPrice: 'club__appointmentNoticeSavingPrice', // в компоненте "ClubAppointmentNotice" экономия
}

export default CLUB_QA_GOALS
